import { useCallback } from "react"
import { StudentNotification, NotificationSubscribeEvent } from "shared/types/notificationTypes"

interface Props {
    notificationEvent: NotificationSubscribeEvent
    onOpenNotification: (notification: StudentNotification) => Promise<void>
    closeToast: () => void
}

const NotificationToastMessage = ({ notificationEvent, onOpenNotification, closeToast } : Props) => {

    const type = notificationEvent.notification.type
    const assignmentTitle = notificationEvent.notification.assignment?.title ?? null

    const openNotification = useCallback(async () => {
        await onOpenNotification(notificationEvent.notification)
        setTimeout(() => {
          closeToast()
        }, 1000)
    }, [onOpenNotification, notificationEvent.notification, closeToast])

    const notificationText = type === "submission-graded" ? `Your submission for ${assignmentTitle} been graded.` : 
        type === "submission-rework" ? `Your submission for ${assignmentTitle} has been requested to resubmit.` : 
        type === "submission-reject" ? `Your submission for ${assignmentTitle} has been rejected.` : "You have a new notification."
  return (
    <div onClick={openNotification}>{notificationText}</div>
  )
}

export default NotificationToastMessage
